import type { ViewIDKey } from '@audacy-clients/core/atoms/config/constants';
import type { EditableItems } from '@audacy-clients/core/atoms/editMode';

export type TMyAudioTabItemType = Exclude<EditableItems, 'downloads'>;

export enum FollowsCategoryTabStrings {
  MyQueue = 'myQueue',
  OnDemands = 'onDemands',
  Recents = 'recents',
  Stations = 'stations',
  Topics = 'topics',
  Playlists = 'playlists',
  Followed = 'followed',
}

export interface ITabConfig {
  href: string;
  title: string;
  itemType: TMyAudioTabItemType;
  viewIdKey: ViewIDKey;
}

export interface IDoubleLevelTabs extends ITabConfig {
  tabs?: ITabConfig[];
}
